import React, { useContext } from 'react'
import { Modal } from 'react-bootstrap';
import BaseBtn from '../common/styled/BaseBtn'
import ModelBody from "../model/sub/ModelBody"
import WhiteBtn from '../../components/common/styled/WhiteBtn'
import BtnGroup from "../model/sub/BtnGroup"
import { createGlobalStyle } from 'styled-components';
import PropTypes from 'prop-types'
import {InjectedConnector} from '@web3-react/injected-connector';
import {TRIAS_SELECTED_WEB3_CONTEXT,THIS_CHAIN_ID} from "../../const";
import {DASHI_ADDRESS} from '../../web3/addresses'
import DASHI from '../../web3/abi/dashi.json'
import {useWeb3React as useWeb3ReactCore} from '@web3-react/core'
import {getContract} from "../../web3";
import {mainContext} from "../../reducer";
import {useTransactionAdder, useDASHIVotes} from "../../hooks";
import Loader from "../common/Loading";


const GlobalStyle = createGlobalStyle`
  .succ-hunter-model {
    .modal-dialog {
      max-width: 460px;
      font-weight: 500;
      color: #333333;
      .text-cont {
        font-size: 20px;
        text-align: center;
      }
      .notice-txt {
        font-size: 14px;
        color: #999;
      }
    }
  }
`

export default function ConfirmSupportHunterModel(props) {
  const isVotes = useDASHIVotes(props.currentHunter.address)
  const addTransaction = useTransactionAdder()

  const {transactions} = useContext(mainContext).state
  const {chainId, account, activate, library, active} = useWeb3ReactCore()

  const supportingStatus = transactions.find((item) => {
    return (
        item.huntervote &&
        props.currentHunter.address === item.huntervote.account &&
        item.huntervote.status === 0
    )
  })

  const toSupport = async ()=> {
    if (active) {
      if(chainId !== THIS_CHAIN_ID && THIS_CHAIN_ID===56){
        if (window.ethereum) {
          window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: `0x${(56).toString(16)}`,
                chainName: 'Binance Smart Chain',
                nativeCurrency: {
                  name: 'BNB',
                  symbol: 'BNB',
                  decimals: 18
                },
                rpcUrls: ['https://bsc-dataseed3.binance.org',
                  'https://bsc-dataseed1.binance.org',
                  'https://bsc-dataseed2.binance.org'],
                blockExplorerUrls: ['https://bscscan.com']
              }
            ]
          })
        }

      }else {
        if (chainId && chainId === THIS_CHAIN_ID && library) {
          const contract = getContract(library, DASHI, DASHI_ADDRESS[chainId], account)
          try {
            const res = await contract.vote(props.currentHunter.address)
            addTransaction(res, {
              huntervote: {
                status: 0,
                chainId,
                account: props.currentHunter.address
              },
              summary: `Support Hunter(${props.currentHunter.name}) Success`,
              hashLink: res.hash,
            })
            // commit success
            props.onSuccess();
          } catch (e) {
            console.log('vote error:', e)
          }
        }
      }
    } else {
      const injected = new InjectedConnector({
        supportedChainIds: [1, 3, 4, 5, 42, 66, 128, 137],
      });
      activate(injected)
          .then(() => {
            window && window.localStorage.setItem(
                TRIAS_SELECTED_WEB3_CONTEXT,
                'MetaMask'
            );
            console.log('connected')
          })
          .catch((e) => {
            console.log('connect error', e)
          });
    }
  }

  return (
    <>
      <GlobalStyle></GlobalStyle>
      <Modal show={props.show} 
        className="succ-hunter-model"
        onHide={props.onHide}
      >
        <Modal.Body>
          <ModelBody>
            <div className="text-cont">
            {props.children}
            </div>
            {isVotes && <div className="notice-txt">You have supported him</div>}
          </ModelBody>
          <BtnGroup>
              <WhiteBtn width="150px" onClick={props.onHide} heigth="42px">Cancel</WhiteBtn>
              <BaseBtn width="150px" heigth="42px"
                disabled={ isVotes ||  supportingStatus}
                onClick={toSupport}
                >
                {isVotes ? 'Supported' : supportingStatus ? 'Supporting' : active ? (THIS_CHAIN_ID === 56 && chainId !== THIS_CHAIN_ID) ? 'Switch to BSC' : 'Confirm' : 'Connect'}
                {supportingStatus && chainId === THIS_CHAIN_ID && <Loader/>}
              </BaseBtn>
            </BtnGroup>
        </Modal.Body>
      </Modal>
    </>
  )
}

ConfirmSupportHunterModel.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  currentHunter: PropTypes.object.isRequired,
}